import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { toAbsoluteUrl } from "../../../_metronic/helpers";

const SubscriptionLayout = () => {
  

  useEffect(() => {
    const root = document.getElementById("root");
    if (root) {
      root.style.height = "100%";
    }
    return () => {
      if (root) {
        root.style.height = "auto";
      }
    };
  }, []);

  return (
    <div className="d-flex flex-column flex-lg-row flex-column-fluid h-100">
      {/* begin::Body */}
      <div className="d-flex flex-column flex-lg-row-fluid w-lg-50 order-2 order-lg-1">
        {/* begin::Form */}
        <div className="d-flex flex-center flex-column flex-lg-row-fluid">
          {/* begin::Wrapper */}
          <div className="w-lg-1200px p-5">
            {/* begin::Content */}
            <div className="d-flex flex-center flex-column flex-column-fluid p-5 pb-lg-5">
              {/* begin::Logo */}
              <a href="#" className="mb-15">
                <img
                  alt="Logo"
                  src={toAbsoluteUrl("media/logos/Logotipo_Adinte-color.png")}
                  className="h-90px"
                />
              </a>
              {/* end::Logo */}
              {/* begin::Wrapper */}
              <div>
                <Outlet />
              </div>
              {/* end::Wrapper */}
            </div>
            {/* end::Content */}
            {/* begin::Footer */}
            <div className="d-flex flex-center flex-column-auto p-5">
              <div className="d-flex align-items-center fw-bold fs-6">
                <a href="https://adinte.legal/terminos-y-condiciones/" className="text-muted text-hover-primary px-2" target="_blank">Términos y condiciones</a><span className="text-muted px-2"> | </span><a href="https://adinte.legal/aviso-de-privacidad/" className="text-muted text-hover-primary px-2" target="_blank">Aviso de privacidad</a>

                {/* <a
                  href="https://app.buscadorcriteria.com.mx/"
                  className="text-muted text-hover-primary px-2"
                >
                  Contacto
                </a> */}

                {/* <a href='#' className='text-muted text-hover-primary px-2'>
                  Contact Us
                </a> */}
              </div>
            </div>
            {/* end::Footer */}
          </div>
          {/* end::Wrapper */}
        </div>
        {/* end::Form */}
      </div>
      {/* end::Body */}
    </div>
  );
};

export { SubscriptionLayout };
